import { useQuery } from '@tanstack/react-query';

import { useCurrentUserStaff } from '@/hooks/useCurrentUserStaff';
import { coachingWorkspaceService } from '@/services/coachingWorkspaceService';
import type { CoachingAccess } from '@/types/coachingWorkspace';

export function coachingScopeKey(access: CoachingAccess | undefined): string {
  if (!access) return '';
  return [access.canCoach ? 'writer' : 'reader', access.canReadAll ? 'all' : access.locationCodes.slice().sort().join(',')].join(':');
}

export const coachingWorkspaceKeys = {
  all: ['coaching-workspace'] as const,
  access: (staffId: string) => ['coaching-workspace', staffId, 'access'] as const,
  snapshot: (staffId: string, on: string, scopeKey: string) => ['coaching-workspace', staffId, 'snapshot', on, scopeKey] as const,
};

export function useCoachingAccess(enabled = true) {
  const { currentUserStaff, isLoading: identityLoading } = useCurrentUserStaff();
  const staffId = currentUserStaff?.id ?? '';
  const query = useQuery({
    queryKey: coachingWorkspaceKeys.access(staffId),
    queryFn: () => coachingWorkspaceService.getAccess(),
    enabled: enabled && !!staffId,
    staleTime: 30_000,
  });
  return { ...query, staffId, scopeKey: coachingScopeKey(query.data), isLoading: identityLoading || query.isLoading };
}
